module.exports = __webpack_public_path__ + "static/media/SelfServicePortalBanne1r.7d6ad242.jpg";